module.exports = __webpack_public_path__ + "static/media/cert_105.47382626.jpg";